import { useSnackbar } from "notistack";
import {
    Typography,
} from "@mui/material";

import { IconTrash, IconPlus } from '@tabler/icons-react';
import { PriceSettingsContainer } from '../../../Styles/Maintenance/priceSettingsStyles';

import { UserTier, PriceSettingsInterface } from '../../../Models/Maintenance/PriceSettings/PriceSettings';

import AccessibilityHelper from '../../../Utilities/Helpers/AccessibilityHelper';

import { ButtonType } from '../../../Utilities/Enums/ButtonTypeEnum';
import { PriceSettingsField } from '../../../Utilities/Enums/ParametersEnum';
import { AdminModules } from '../../../Utilities/Enums/AdminModulesEnum';

import { ErrorMessage } from "../../../Constants/Messages";

import CustomButton from '../../../CustomViews/Elements/CustomButton';
import CustomIconButton from '../../../CustomViews/Elements/CustomIconButton';
import FormTextField from '../../../CustomViews/Elements/FormTextField';

export default function UserTiersSettings(props: PriceSettingsInterface) {
    //Variables
    const { enqueueSnackbar } = useSnackbar();
    let { formData, setformData, errorMessages, setopenDelete, settoDeleteItem, setdeleteType, userTierTempId, setuserTierTempId, userTierCount, setuserTierCount } = props;
    let _lastUserTierIndex: number =  userTierCount - 1;
    
    let minUsersProps: any = [];
    let maxUsersProps: any = [];
    let userDiscountProps: any = [];

    if(userTierCount > 0) {
        formData?.[PriceSettingsField.USER_TIERS]?.forEach((userTierItem: any, utIndex: any) => {
            minUsersProps.push({
                name: PriceSettingsField.MIN_USERS + userTierItem?.tempId,
                title: 'Min Users',
                fieldValue: userTierItem?.[PriceSettingsField.MIN_USERS] ?? "",
                hideLabel: true,
                type: 'number',
                disabled: true,
                // required: requiredFields?.find((field: any) => field.keyName == ModuleSettingField.NAME)?.keyName != null,
                errorMessages: errorMessages,
                handleOnChange: (selectedValue: any) => {
                    let _userTiers: UserTier[]  = formData?.[PriceSettingsField.USER_TIERS] ?? [];

                    _userTiers[utIndex] = {
                        ..._userTiers[utIndex],
                        [PriceSettingsField.MIN_USERS]: selectedValue ?? ""
                    };

                    if(setformData) {
                        setformData((prev: any) => ({ ...prev, [PriceSettingsField.USER_TIERS]: _userTiers }));
                    }
                },
            });

            maxUsersProps.push({
                name: PriceSettingsField.MAX_USERS + userTierItem?.tempId,
                title: 'Max Users',
                fieldValue: userTierItem?.[PriceSettingsField.MAX_USERS] ?? "",
                hideLabel: true,
                disabled: !AccessibilityHelper.hasAccess(AdminModules.PRICE_SETTINGS_EDIT),
                type: 'number',
                // required: requiredFields?.find((field: any) => field.keyName == ModuleSettingField.NAME)?.keyName != null,
                errorMessages: errorMessages,
                handleOnChange: (selectedValue: any) => {
                    let _userTiers: UserTier[]  = formData?.[PriceSettingsField.USER_TIERS] ?? [];
                    let _newlySelectedValue = isNaN(parseFloat(selectedValue?.toString() ?? "1")) ? 0 : parseFloat(selectedValue?.toString() ?? "1");

                    _userTiers[utIndex] = {
                        ..._userTiers[utIndex],
                        [PriceSettingsField.MAX_USERS]: selectedValue ?? ""
                    };

                    if(_userTiers[utIndex + 1]?.[PriceSettingsField.MIN_USERS]) {
                        let minNewValue = _newlySelectedValue + 1;

                        _userTiers[utIndex + 1] = {
                            ..._userTiers[utIndex + 1],
                            [PriceSettingsField.MIN_USERS]: minNewValue,
                        };
                    }

                    if(setformData) {
                        setformData((prev: any) => ({ ...prev, [PriceSettingsField.USER_TIERS]: _userTiers }));
                    }
                },
            });

            userDiscountProps.push({
                name: PriceSettingsField.USERDISCOUNT + userTierItem?.tempId,
                title: 'Discount %',
                fieldValue: userTierItem?.[PriceSettingsField.USERDISCOUNT] ?? "",
                hideLabel: true,
                disabled: !AccessibilityHelper.hasAccess(AdminModules.PRICE_SETTINGS_EDIT),
                type: 'number',
                // required: requiredFields?.find((field: any) => field.keyName == ModuleSettingField.NAME)?.keyName != null,
                errorMessages: errorMessages,
                handleOnChange: (selectedValue: any) => {
                    let _userTiers: UserTier[]  = formData?.[PriceSettingsField.USER_TIERS] ?? [];

                    _userTiers[utIndex] = {
                        ..._userTiers[utIndex],
                        [PriceSettingsField.USERDISCOUNT]: selectedValue ?? ""
                    };

                    if(setformData) {
                        setformData((prev: any) => ({ ...prev, [PriceSettingsField.USER_TIERS]: _userTiers }));
                    }
                },
            });
        }); 
    }

    //Event Handlers
    
    //Rendering Functions
    return <PriceSettingsContainer>
        <Typography className="settingItemHeader" color="primaryText">User Tiers</Typography>
        <Typography className="settingItemFieldHeader">Min Users</Typography>
        <Typography className="settingItemFieldHeader">Max Users</Typography>
        <Typography className="settingItemFieldHeader span2Item">Discount %</Typography>

        {formData?.[PriceSettingsField.USER_TIERS]?.map((ut: any, usetTierIndex: number) => (<>
            <FormTextField {...minUsersProps[usetTierIndex]} />
            <FormTextField {...maxUsersProps[usetTierIndex]} />
            <FormTextField {...userDiscountProps[usetTierIndex]} />

            {AccessibilityHelper.hasAccess(AdminModules.PRICE_SETTINGS_DELETE) ? <CustomIconButton toolTipName='Delete'
                icon={<IconTrash color='var(--buttonHoverBGDangerColor)' />}
                onClick={(e: any) => {
                    if(setopenDelete) {
                        setopenDelete(true);
                    }

                    if(settoDeleteItem) {
                        settoDeleteItem({ index: usetTierIndex, name: null });
                    }

                    if(setdeleteType) {
                        setdeleteType('userTier');
                    }
                }} /> : <div />}
        </>))}

       {AccessibilityHelper.hasAccess(AdminModules.PRICE_SETTINGS_CREATE) && <CustomButton
            btnType={ButtonType.CANCEL}
            title='Add Tier'
            startIcon={<IconPlus />}
            // isRoundedCorner={true}
            onClick={(e: any) => {
                let _userTiers: UserTier[]  = formData?.[PriceSettingsField.USER_TIERS] ?? [];
                
                let _userTierTempId = (userTierTempId ?? 0) + 1;
                let _newMinUser: any = parseFloat(formData?.[PriceSettingsField.USER_TIERS]?.[_lastUserTierIndex]?.[PriceSettingsField.MAX_USERS]?.toString() ?? '0');

                if(_newMinUser > 1) {
                    if(setformData) {
                        setformData((prev: any) => ({
                            ...prev, 
                            [PriceSettingsField.USER_TIERS]: [
                                ..._userTiers,
                                {
                                    ...new UserTier(),
                                    [PriceSettingsField.MIN_USERS]: _newMinUser + 1,
                                    tempId: _userTierTempId,
                                }
                            ]
                        }));
                    }

                    if(setuserTierTempId) {
                        setuserTierTempId(_userTierTempId);
                    }
                    
                    if(setuserTierCount) {
                        setuserTierCount((userTierCount ?? 0) + 1);
                    }
                } else {
                    enqueueSnackbar(ErrorMessage.CANNOT_PROCEED_ADDING_USER_TIER, { variant: 'error'});
                }
            }} />}
    </PriceSettingsContainer>
}